<div class="pagination-wrapper">
  <div class="rows-per-page">
    <label for="pageSizeSelect">Rows per page:</label>
    <select id="pageSizeSelect" [ngModel]="pageSize" (change)="onPageSizeSelect($event)">
      <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</option>
    </select>
  </div>

  <div class="record-range" *ngIf="collectionSize > 0">
    {{ rangeStart }}–{{ rangeEnd }} of {{ collectionSize }}
  </div>

  <ngb-pagination [collectionSize]="collectionSize" [pageSize]="pageSize" [(page)]="page" [maxSize]="7"
    (pageChange)="onPageChange.emit($event)" [rotate]="true" [ellipses]="false" [boundaryLinks]="false">
    <ng-template ngbPaginationPrevious>
      <img src="../assets/images/chevron-left.svg" alt="Previous" />
    </ng-template>
    <ng-template ngbPaginationNext>
      <img src="../assets/images/chevron-right.svg" alt="Next" />
    </ng-template>
  </ngb-pagination>
</div>